<template>
	<div class="base_box">
		<baseCrumbs :list="crumbs"></baseCrumbs>
		<div class="base_content head">
			<el-tabs v-model="activeName" @tab-click="jump">
				<el-tab-pane :label="tab.label" :name="tab.name" v-for="tab in tabs" :key="tab.name"></el-tab-pane>
			</el-tabs>
		</div>

		<!-- 表单区域 -->
		<div class="content scroll-content" @scroll="onScroll" :style="
        'overflow-x: hidden; overflow-y: auto;height:' + contentStyleObj.height
      ">
			<!-- 基本信息 -->
			<div class="base_form base_form_padding mt10 scroll-item" ref="first">
				<div class="base_form_title">基本信息</div>
				<el-form class="mt20 ml15" ref="form" :model="form" :rules="rules" label-width="90px"
					style="margin-bottom: 16px" hide-required-asterisk>
					<!-- 活动类型 -->
					<el-form-item label="活动类型" prop="apply_type">
						<el-radio-group v-model="form.apply_type">
							<el-radio :label="1">图片投票</el-radio>
							<el-radio :label="2">视频投票</el-radio>
						</el-radio-group>
						<div class="base_tips mt5">活动类型: 在创建活动保存后无法修改,请谨慎选择。</div>
					</el-form-item>

					<!-- 活动名称 -->
					<el-form-item label="活动名称" prop="title">
						<el-input placeholder="请输入活动名称" size="small" v-model="form.title" type="text"
							style="width: 400px"></el-input>
					</el-form-item>

					<!-- 活动封面 -->
					<el-form-item label="活动封面" prop="cover_image">
						<div class="goodsimage">
							<div class="imgbox" @click="
                  imgplugin.count = 1;
                  imgplugin.multiple = false;
                  openimgplugin('cover', 1);
                ">
								<el-image v-if="form.cover_image" :src="typeof form.cover_image === 'object' ? form.cover_image.url : form.cover_image" fit="cover"></el-image>
								<i v-if="!form.cover_image" class="el-icon-plus addicon"></i>
								<div v-if="!form.cover_image" class="text">添加图片</div>
							</div>
						</div>
						<div class="base_tips mt5">建议尺寸: 750*240,高度根据图片的高度自适应。</div>
					</el-form-item>

					<!-- 活动背景图 -->
					<el-form-item label="活动背景图" prop="main_image_id">
						<div class="goodsimage">
							<div class="imgbox" @click="
                  imgplugin.count = 1;
                  imgplugin.multiple = false;
                  openimgplugin('main', 1);
                ">
								<el-image v-if="form.main_image_id" :src="typeof form.main_image_id === 'object' ? form.main_image_id.url : form.main_image_id" fit="cover"></el-image>
								<i v-if="!form.main_image_id" class="el-icon-plus addicon"></i>
								<div v-if="!form.main_image_id" class="text">添加图片</div>
							</div>
						</div>
					</el-form-item>

					<!-- 活动背景 -->
					<el-form-item label="活动背景">
						<el-button-group>
							<el-button :class="{ active: form.bg_type == 'color' }" @click="form.bg_type = 'color'">纯色</el-button>
							<el-button :class="{ active: form.bg_type == 'image' }" @click="form.bg_type = 'image'">图片</el-button>
						</el-button-group>
					</el-form-item>

					<!-- 背景纯色 -->
					<el-form-item label="背景纯色" v-if="form.bg_type == 'color'">
						<el-color-picker v-model="form.bg_color" @change="handleColorChange" class="color-picker" />
						<el-input v-model="form.bg_color" class="color-input" style="width: 100px" />
						<el-button size="small" @click="resetBgColor" class="reset-btn">重置</el-button>
					</el-form-item>

					<!-- 背景图片 -->
					<el-form-item label="背景图片" v-if="form.bg_type == 'image'">
						<div class="goodsimage">
							<div class="imgbox" @click="
                  imgplugin.count = 1;
                  imgplugin.multiple = false;
                  openimgplugin('bg', 1);
                ">
								<el-image v-if="form.bg_image" :src="form.bg_image" fit="cover"></el-image>
								<i v-if="!form.bg_image" class="el-icon-plus addicon"></i>
								<div v-if="!form.bg_image" class="text">添加图片</div>
							</div>
						</div>
					</el-form-item>

					<!-- 报名时间 -->
					<el-form-item label="报名时间" prop="apply_time">
						<el-date-picker
							v-model="form.apply_start_time"
							type="datetime"
							placeholder="开始时间"
							size="small"
						></el-date-picker>
						<span class="time-span">至</span>
						<el-date-picker
							v-model="form.apply_end_time"
							type="datetime"
							placeholder="结束时间"
							size="small"
						></el-date-picker>
					</el-form-item>

					<!-- 比赛时间 -->
					<el-form-item label="比赛时间" prop="match_time">
						<el-date-picker
							v-model="form.match_start_time"
							type="datetime"
							placeholder="开始时间"
							size="small"
						></el-date-picker>
						<span class="time-span">至</span>
						<el-date-picker
							v-model="form.match_end_time"
							type="datetime"
							placeholder="结束时间"
							size="small"
						></el-date-picker>
					</el-form-item>

					<!-- 活动地址 -->
					<el-form-item label="活动地址" prop="address">
						<el-input placeholder="请输入活动地址" size="small" v-model="form.address" type="text"
							style="width: 400px"></el-input>
					</el-form-item>
				</el-form>
			</div>

			<!-- 活动规则 -->
			<div class="base_form base_form_padding mt10 scroll-item" ref="second">
				<div class="base_form_title">活动规则</div>
				<el-form class="mt20 ml15" ref="form" :model="form" label-width="90px"
					style="margin-bottom: 16px">
					<!-- 投票方式 -->
					<el-form-item label="投票方式">
						<el-checkbox-group v-model="form.vote_methods">
							<el-checkbox :label="'normal'">常规投票</el-checkbox>
							<el-checkbox :label="'video'">观看激励视频</el-checkbox>
							<el-checkbox :label="'gift'">礼物</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<!-- 投票方式详细设置 -->
					<div v-if="form.vote_methods.length > 0" class="vote-settings-panel">
						<!-- 常规投票设置 -->
						<template v-if="form.vote_methods.includes('normal')">
							<el-form-item label="*用户投票总次数">
								<el-input placeholder="请输入用户投票总次数" size="small" v-model.number="form.vote_total_num" type="number"
									style="width: 200px"></el-input>
							</el-form-item>
							<el-form-item label="*用户每日投票次数">
								<el-input placeholder="请输入用户每日投票次数" size="small" v-model.number="form.vote_daily_num" type="number"
									style="width: 200px"></el-input>
								<div class="base_tips mt5">用户投票总次数：指用户针对选手投票的总次数，每日投票次数：指用户每日可对选手投票次数。</div>
							</el-form-item>
						</template>

						<!-- 观看激励视频设置 -->
						<template v-if="form.vote_methods.includes('video')">
							<el-form-item label="*激励视频广告ID">
								<el-input placeholder="请输入激励视频广告ID" size="small" v-model="form.ad_id"
									style="width: 400px"></el-input>
							</el-form-item>
							<el-form-item label="*每日可观看次数">
								<el-input placeholder="请输入每日可观看次数" size="small" v-model.number="form.vote_ad_num" type="number"
									style="width: 200px"></el-input>
								<div class="base_tips mt5">在微信公众号内的投票主页面激励视频广告，每日可观看次数为：1次为限，如果每日已满，那么填写每日可观看次数为0</div>
							</el-form-item>
						</template>

						<!-- 礼物设置 -->
						<template v-if="form.vote_methods.includes('gift')">
							<el-form-item label="礼物">
								<el-checkbox v-model="form.vote_gift_status">勾选礼物后消费者可通过礼物进行投票。</el-checkbox>
							</el-form-item>
						</template>
					</div>

					<!-- 活动阶段 -->
					<el-form-item label="活动阶段">
						<el-switch v-model="form.stage_open" active-text="开启" inactive-text="关闭"></el-switch>
						<div class="base_tips mt5">如果不需要比赛阶段，那么选择关闭即可。开启比赛阶段，必须要最少添加一个比赛阶段。</div>
					</el-form-item>

					<!-- 阶段列表 -->
					<el-form-item v-if="form.stage_open">
						<div class="stage-table">
							<div class="stage-table-header">
								<div class="stage-col">排序</div>
								<div class="stage-col">活动阶段名</div>
								<div class="stage-col">开始时间</div>
								<div class="stage-col">结束时间</div>
								<div class="stage-col">操作</div>
							</div>
							<div class="stage-table-body">
								<div v-for="(stage, index) in form.stageList" :key="index" class="stage-row">
									<div class="stage-col">{{ stage.stage_sort }}</div>
									<div class="stage-col">
										<el-input placeholder="请输入阶段名称" size="small" v-model="stage.stage_name" style="width: 150px"></el-input>
									</div>
									<div class="stage-col">
										<el-date-picker v-model="stage.start_time" type="datetime" size="small" placeholder="请选择开始时间"></el-date-picker>
									</div>
									<div class="stage-col">
										<el-date-picker v-model="stage.end_time" type="datetime" size="small" placeholder="请选择结束时间"></el-date-picker>
									</div>
									<div class="stage-col">
										<el-button v-if="form.stageList.length > 1" type="text" @click="removeStage(index)">删除</el-button>
									</div>
								</div>
							</div>
							<div class="stage-table-footer">
								<el-button type="primary" size="small" @click="addStage">+添加比赛阶段</el-button>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>

			<!-- 活动参与单位 -->
			<div class="base_form base_form_padding mt10 scroll-item" ref="third">
				<div class="base_form_title">活动参与单位</div>
				<el-form class="mt20 ml15" ref="form" :model="form" label-width="90px"
					style="margin-bottom: 16px">
					<!-- 参与单位开关 -->
					<el-form-item label="参与单位">
						<el-switch v-model="form.organizers_open" active-text="开启" inactive-text="关闭"></el-switch>
					</el-form-item>
					<div class="base_tips mt5">参与名称描述和参与单位名称，可设置多个参与单位。举例：主办方：四川点子王五联电子商务有限公司。</div>

					<!-- 参与单位列表 -->
					<el-form-item v-if="form.organizers_open">
						<div class="organizer-table">
							<div class="organizer-table-header">
								<div class="organizer-col">名称描述</div>
								<div class="organizer-col">参与单位名称</div>
								<div class="organizer-col">操作</div>
							</div>
							<div class="organizer-table-body">
								<div v-for="(organizer, index) in form.organizersList" :key="index" class="organizer-row">
									<div class="organizer-col">
										<el-input placeholder="请输入名称描述" size="small" v-model="organizer.type" style="width: 150px"></el-input>
									</div>
									<div class="organizer-col">
										<el-input placeholder="请输入参与单位名称" size="small" v-model="organizer.name" style="width: 300px"></el-input>
									</div>
									<div class="organizer-col">
										<el-button v-if="form.organizersList.length > 1" type="text" @click="removeOrganizer(index)">删除</el-button>
									</div>
								</div>
							</div>
							<div class="organizer-table-footer">
								<el-button type="primary" size="small" @click="addOrganizer">+添加赛事单位</el-button>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>

			<!-- 活动详情 -->
			<div class="base_form base_form_padding mt10 scroll-item" ref="fourth">
				<div class="base_form_title">活动详情</div>
				<el-form class="mt20 ml15" label-width="90px" style="margin-bottom: 16px" hide-required-asterisk>
					<el-form-item>
						<TinymceEditor v-model="form.description" :height="300"></TinymceEditor>
					</el-form-item>
				</el-form>
			</div>

			<!-- 底部按钮 -->
			<div class="base_form base_form_padding mt10">
				<div class="form_button">
					<el-button @click="goBack">取消</el-button>
					<el-button type="primary" @click="submitFun">{{ isEdit ? '确认编辑' : '确认添加' }}</el-button>
				</div>
			</div>
		</div>

		<!-- 图片选择器 -->
		<xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple"
			:count="imgplugin.count" is_rest>
		</xsk-manage>
	</div>
</template>

<script>
import TinymceEditor from '@/components/TinymceEditor/TinymceEditor'

export default {
	name: 'CompetitionAdd',
	components: {
		TinymceEditor
	},
	data() {
		return {
			activeName: 'first',
			isEdit: false,
			editId: '',
			crumbs: [],
			tabs: [
				{ label: '基本信息', name: 'first' },
				{ label: '活动规则', name: 'second' },
				{ label: '参与单位', name: 'third' },
				{ label: '活动详情', name: 'fourth' }
			],
			form: {
				title: '',
				cover_image: '',
				main_image_id: '',
				bg_type: 'color',
				bg_color: '#ffffff',
				bg_image: '',
				apply_start_time: '',
				apply_end_time: '',
				match_start_time: '',
				match_end_time: '',
				address: '',
				vote_methods: ['normal'],
				vote_count: 10,
				vote_ad_num: 5,
				vote_daily_num: 1,
				vote_gift_status: false,
				max_sign: 500,
				sort: 100,
				apply_type: 1,
				stage_open: false,
				stageList: [
					{ stage_name: '海选赛', stage_sort: 0, start_time: '', end_time: '' },
					{ stage_name: '入围赛', stage_sort: 1, start_time: '', end_time: '' }
				],
				organizers_open: false,
				organizersList: [
					{ type: '举办方', name: '' },
					{ type: '协办方', name: '' }
				],
				description: '',
				intro: ''
			},
			imgplugin: {
				show: false,
				multiple: false,
				count: 1,
				imgName: ''
			},
			contentStyleObj: {
				height: 'calc(100vh - 200px)'
			},
			rules: {
				apply_time: [
					{ validator: this.validateApplyTime, trigger: 'blur' }
				],
				match_time: [
					{ validator: this.validateMatchTime, trigger: 'blur' }
				]
			}
		}
	},
	watch: {
		'form.apply_end_time'(val) {
			if (val) {
				const endDate = new Date(val)
				const currentHours = endDate.getHours()
				const currentMinutes = endDate.getMinutes()
				const currentSeconds = endDate.getSeconds()
				if (currentHours !== 23 || currentMinutes !== 59 || currentSeconds !== 59) {
					endDate.setHours(23, 59, 59, 999)
					this.$nextTick(() => {
						this.form.apply_end_time = endDate
					})
				}
			}
		},
		'form.match_end_time'(val) {
			if (val) {
				const endDate = new Date(val)
				const currentHours = endDate.getHours()
				const currentMinutes = endDate.getMinutes()
				const currentSeconds = endDate.getSeconds()
				if (currentHours !== 23 || currentMinutes !== 59 || currentSeconds !== 59) {
					endDate.setHours(23, 59, 59, 999)
					this.$nextTick(() => {
						this.form.match_end_time = endDate
					})
				}
			}
		}
	},
	created() {
		let _this = this
		// 从sessionStorage获取面包屑信息
		let crumbs = []
		try {
			const storedCrumbs = sessionStorage.getItem('competition_crumbs')
			if (storedCrumbs) {
				crumbs = JSON.parse(storedCrumbs)
				sessionStorage.removeItem('competition_crumbs')
			}
		} catch (e) {
			console.error('解析面包屑失败:', e)
		}
		_this.crumbs = crumbs.length > 0 ? crumbs : [
			{ name: '投票活动', path: '/application/competition/list', query: '' },
			{ name: '添加活动', path: '', query: '' },
		]
		
		// 计算内容区域高度
		_this.getHight()
		
		const id = this.$route.params.id
		if (id) {
			this.isEdit = true
			this.editId = id
			// 修改面包屑名称
			if (_this.crumbs.length > 1) {
				_this.crumbs[_this.crumbs.length - 1].name = '编辑活动'
			}
			this.loadData(id)
		}
		
		// 添加窗口resize事件监听
		window.addEventListener("resize", _this.getHight)
	},
	destroyed() {
		// 移除窗口resize事件监听
		window.removeEventListener("resize", this.getHight)
	},
	methods: {
		// 验证报名时间
		validateApplyTime(rule, value, callback) {
			const start = this.form.apply_start_time
			const end = this.form.apply_end_time
			if (start && end) {
				if (new Date(end).getTime() < new Date(start).getTime()) {
					callback(new Error('报名结束时间不能小于开始时间'))
					return
				}
			}
			callback()
		},
		// 验证比赛时间
		validateMatchTime(rule, value, callback) {
			const start = this.form.match_start_time
			const end = this.form.match_end_time
			if (start && end) {
				if (new Date(end).getTime() < new Date(start).getTime()) {
					callback(new Error('比赛结束时间不能小于开始时间'))
					return
				}
			}
			callback()
		},
		loadData(id) {
			const _this = this
			const url = '/api/sing/admin/competition/detail/' + id
			console.log('获取活动详情:', url)
			this.axios.get(url).then(res => {
				console.log('活动详情返回:', res)
				if (res.code == 200) {
					var data = res.data
					_this.form = {
						..._this.form,
						id: data.id || '',
						title: data.title || '',
						cover_image: data.cover_image || '',
						main_image_id: data.main_image || '',
						intro: data.intro || '',
						description: data.intro || '',
						apply_start_time: data.start_time || '',
						apply_end_time: data.end_time || '',
						match_start_time: data.match_start_time || '',
						match_end_time: data.match_end_time || '',
						address: data.address || '',
						max_sign: data.max_sign || 0,
						sort: data.sort || 100,
						status: data.status || 1,
						apply_type: data.apply_type || 1,
						apply_way: data.apply_way || 1,
						ad_id: data.ad_id || '',
						vote_ad_num: data.vote_ad_num || 0,
						vote_daily_num: data.vote_daily_num || 0,
						vote_gift_status: data.vote_gift_status || 0,
						vote_total_num: data.vote_total_num || 0,
						bg_color: data.bg_color || '#ffffff',
						bg_image: data.bg_image || '',
						bg_type: data.bg_image ? 'image' : 'color',
						stage_open: data.stage_show == 1,
						stage_show: data.stage_show || 0,
						organizers_open: data.organizers ? true : false
					}
					if (data.stage_list) {
						try {
							_this.form.stageList = JSON.parse(data.stage_list)
						} catch (e) {
							_this.form.stageList = [{ stage_name: '海选赛', stage_sort: 1, start_time: '', end_time: '' }]
						}
					}
					if (data.organizers) {
						try {
							_this.form.organizersList = JSON.parse(data.organizers)
						} catch (e) {
							_this.form.organizersList = [{ type: '主办方', name: '' }]
						}
					}
					_this.form.vote_methods = []
					if (data.vote_total_num > 0 || data.vote_daily_num > 0) {
						_this.form.vote_methods.push('normal')
					}
					if (data.vote_ad_num > 0) {
						_this.form.vote_methods.push('video')
					}
					if (data.vote_gift_status == 1) {
						_this.form.vote_methods.push('gift')
					}
				}
			}).catch(function(err) {
				console.error('获取活动详情失败:', err)
			})
		},
		jump(tab) {
			this.$refs[tab.name] && this.$refs[tab.name].scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
		getHight() {
			let height = window.innerHeight - 200
			this.contentStyleObj.height = height + 'px'
		},
		onScroll(e) {
			let scrollTop = e.target.scrollTop
			let tabs = ['first', 'second', 'third', 'fourth']
			for (let i = tabs.length - 1; i >= 0; i--) {
				let el = this.$refs[tabs[i]]
				if (el && el.offsetTop <= scrollTop + 200) {
					this.activeName = tabs[i]
					break
				}
			}
		},
		openimgplugin(type) {
			this.imgplugin.show = true
			this.imgplugin.imgName = type
		},
		imgpluginFun(obj) {
			if (obj && obj.imgobjs && obj.imgobjs.length > 0) {
				const imgData = obj.imgobjs[0]
				if (this.imgplugin.imgName === 'cover') {
					this.form.cover_image = {
						id: imgData.id,
						url: imgData.url || imgData.base_url || imgData.path || imgData.src
					}
				} else if (this.imgplugin.imgName === 'main') {
					this.form.main_image_id = {
						id: imgData.id,
						url: imgData.url || imgData.base_url || imgData.path || imgData.src
					}
				} else if (this.imgplugin.imgName === 'bg') {
					this.form.bg_image = {
						id: imgData.id,
						url: imgData.url || imgData.base_url || imgData.path || imgData.src
					}
				}
			}
		},
		handleColorChange(val) {
			this.form.bg_color = val
		},
		resetBgColor() {
			this.form.bg_color = '#ffffff'
		},
		addStage() {
			this.form.stageList.push({ stage_name: '', stage_sort: this.form.stageList.length + 1, start_time: '', end_time: '' })
		},
		removeStage(index) {
			this.form.stageList.splice(index, 1)
		},
		addOrganizer() {
			this.form.organizersList.push({ type: '主办方', name: '' })
		},
		removeOrganizer(index) {
			this.form.organizersList.splice(index, 1)
		},
		goBack() {
			this.$router.push('/application/competition/list')
		},
		formatDateTime(date) {
			if (!date) return ''
			let d = new Date(date)
			// 处理时区问题：如果日期字符串包含 'Z' 表示UTC时间，需要加上时区偏移
			if (typeof date === 'string' && date.includes('Z')) {
				let offset = d.getTimezoneOffset() // 返回的是分钟数，东八区返回-480
				d = new Date(d.getTime() - offset * 60 * 1000)
			}
			let year = d.getFullYear()
			let month = String(d.getMonth() + 1).padStart(2, '0')
			let day = String(d.getDate()).padStart(2, '0')
			let hours = String(d.getHours()).padStart(2, '0')
			let minutes = String(d.getMinutes()).padStart(2, '0')
			let seconds = String(d.getSeconds()).padStart(2, '0')
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
		},
		submitFun() {
			let data = {
				title: this.form.title,
				start_time: this.formatDateTime(this.form.apply_start_time),
				end_time: this.formatDateTime(this.form.apply_end_time),
				match_start_time: this.formatDateTime(this.form.match_start_time),
				match_end_time: this.formatDateTime(this.form.match_end_time),
				address: this.form.address,
				apply_type: this.form.apply_type,
				apply_way: this.form.apply_way || 1
			}
			// 可选字段
			if (this.form.cover_image) {
				data.cover_image = typeof this.form.cover_image === 'object' ? this.form.cover_image.id : this.form.cover_image
			}
			if (this.form.main_image_id) {
				data.main_image_id = typeof this.form.main_image_id === 'object' ? this.form.main_image_id.id : this.form.main_image_id
			}
			if (this.form.description) {
				data.intro = this.form.description
			}
			if (this.form.max_sign > 0) {
				data.max_sign = this.form.max_sign
			}
			if (this.form.sort > 0) {
				data.sort = this.form.sort
			}
			if (this.form.status !== undefined) {
				data.status = this.form.status
			}
			// 投票方式相关字段
			if (this.form.vote_daily_num > 0) {
				data.vote_daily_num = this.form.vote_daily_num
			}
			if (this.form.vote_ad_num > 0) {
				data.vote_ad_num = this.form.vote_ad_num
			}
			if (this.form.vote_gift_status) {
				data.vote_gift_status = 1
			}
			if (this.form.vote_total_num !== undefined) {
				data.vote_total_num = this.form.vote_total_num
			}
			if (this.form.ad_id) {
				data.ad_id = this.form.ad_id
			}
			// 举办/协办方信息
			if (this.form.organizers_open && this.form.organizersList.length > 0) {
				data.organizers = JSON.stringify(this.form.organizersList)
			}
			// 背景设置
			if (this.form.bg_type === 'color' && this.form.bg_color) {
				data.bg_color = this.form.bg_color
			}
			if (this.form.bg_type === 'image' && this.form.bg_image) {
				data.bg_image = typeof this.form.bg_image === 'object' ? this.form.bg_image.id : this.form.bg_image
			}
			// 比赛阶段
			if (this.form.stage_open && this.form.stageList.length > 0) {
				data.stage_show = 1
				let stageList = this.form.stageList.map(stage => ({
					...stage,
					start_time: this.formatDateTime(stage.start_time),
					end_time: this.formatDateTime(stage.end_time)
				}))
				data.stage_list = JSON.stringify(stageList)
			}
			let url = this.isEdit ? `/api/sing/admin/competition/edit/${this.editId}` : '/api/sing/admin/competition/add'
			this.axios.post(url, data).then(res => {
				if (res.code === 200) {
					this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
					this.$router.push('/application/competition/list')
				} else {
					this.$message.error(res.msg || '添加失败')
				}
			}).catch(err => {
				this.$message.error('添加失败')
			})
		}
	}
}
</script>

<style lang="less" scoped>
::v-deep .el-form-item__content {
	display: flex;
	align-items: center;
	gap: 10px;
}

.base_form_title {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	padding-bottom: 10px;
	border-bottom: 1px solid #eee;
	margin-bottom: 10px;
}

.form_button {
	text-align: center;
	padding: 20px;
}

.goodsimage {
	display: flex;
	flex-wrap: wrap;
}

.imgbox {
	width: 150px;
	height: 80px;
	border: 1px dashed #ddd;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-right: 10px;
	margin-bottom: 10px;
	cursor: pointer;
	overflow: hidden;

	.el-icon-plus {
		font-size: 24px;
		color: #ccc;
	}

	.text {
		font-size: 12px;
		color: #999;
		margin-top: 5px;
	}

	.el-image {
		width: 100%;
		height: 100%;
	}
}

.el-button-group .el-button.active {
	background-color: #1890ff;
	color: #fff;
	border-color: #1890ff;
}

.el-button-group .el-button:not(.active) {
	background-color: #fff;
	color: #666;
	border-color: #d9d9d9;
}

.time-span {
	margin: 0 10px;
	color: #666;
}

.vote-settings-panel {
	background: #fafafa;
	padding: 15px;
	margin-top: 10px;
	border-radius: 4px;
}

.stage-table, .organizer-table {
	width: 100%;
	border: 1px solid #e8e8e8;
	border-radius: 4px;
	overflow: hidden;
	font-size: 14px;
}

.stage-table-header, .organizer-table-header {
	display: flex;
	width: 100%;
	background: #fafafa;
	border-bottom: 1px solid #e8e8e8;
}

.stage-table-header .stage-col, 
.stage-table-header .organizer-col,
.organizer-table-header .stage-col, 
.organizer-table-header .organizer-col {
	padding: 10px 15px;
	font-weight: bold;
	color: #333;
	flex: 1;
}

.stage-table-header .stage-col:first-child,
.organizer-table-header .organizer-col:first-child {
	width: 120px;
	flex: none;
}

.stage-table-header .stage-col:last-child,
.organizer-table-header .organizer-col:last-child {
	width: 80px;
	flex: none;
	text-align: center;
}

.stage-table-body, .organizer-table-body {
	background: #fff;
}

.stage-row, .organizer-row {
	display: flex;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;
	align-items: center;
	
	&:last-child {
		border-bottom: none;
	}
}

.stage-row .stage-col,
.stage-row .organizer-col,
.organizer-row .stage-col,
.organizer-row .organizer-col {
	padding: 10px 15px;
	flex: 1;
}

.stage-row .stage-col:first-child,
.organizer-row .organizer-col:first-child {
	width: 120px;
	flex: none;
}

.stage-row .stage-col:last-child,
.organizer-row .organizer-col:last-child {
	width: 80px;
	flex: none;
	text-align: center;
}

.stage-table-footer, .organizer-table-footer {
	padding: 10px 15px;
	text-align: right;
	background: #fafafa;
}

.base_tips {
	font-size: 12px;
	color: #999;
	line-height: 1.5;
}
</style>
